export enum ToastMessageAccent {
  Neutral = 'neutral',
  Positive = 'positive',
  Waring = 'warning',
  Alert = 'alert'
}

// source of icons: Spark Iconography Library
export enum ToastMessageIcon {
  AlertOctogon = 'alert-warning-octogon'
}

export interface ToastMessage {
  readonly text: string;
  readonly accent: ToastMessageAccent;
  readonly icon?: ToastMessageIcon;
}
